<template>
  <v-container class="px-0 ma-0 py-3 lead-info">
    <v-row no-gutters>
      <!-- {{ store.singleLeadData }} -->
      <v-col class="d-flex align-center ga-5 mb-5" cols="12">
        <div>
          <button @click="goBack" class="back-btn">
            <img :src="backIcon" alt="backIcon" />
          </button>
        </div>
        <div class="user-info d-flex align-center ga-2">
          <span v-if="store?.singleLeadData?.first_name">
            {{ store.singleLeadData.first_name.slice(0, 1) }}
          </span>
          <p v-if="store?.singleLeadData?.first_name">
            {{ store?.singleLeadData?.first_name }}
            {{ store?.singleLeadData?.last_name }}
          </p>
        </div>
      </v-col>
      <v-col v-if="!store.edite_card" cols="12" class="card-info">
        <v-card class="pa-6" rounded="lg" elevation="3">
          <div
            class="card-header mb-6 d-flex align-center justify-space-between"
          >
            <h2>Lead Information</h2>
            <button @click="onEdit">
              <img :src="editIcon" alt="editIcon" />
              Edit
            </button>
          </div>
          <div class="card-body">
            <v-row no-gutters>
              <v-col cols="12" md="5" lg="5" xl="5">
                <div
                  class="lead-line lead-time d-flex align-center justify-space-between"
                >
                  <p class="title">Leads Generation time</p>
                  <p
                    class="value"
                    v-if="store?.singleLeadData?.lead_genration_time"
                  >
                    {{ formattedLeadTime }}
                  </p>
                </div>
                <div
                  class="lead-line first-name d-flex align-center justify-space-between"
                >
                  <p class="title">First Name</p>
                  <p class="value" v-if="store?.singleLeadData?.first_name">
                    {{ store?.singleLeadData?.first_name }}
                  </p>
                </div>
                <div
                  class="lead-line last-name d-flex align-center justify-space-between"
                >
                  <p class="title">Last Name</p>
                  <p class="value" v-if="store?.singleLeadData?.last_name">
                    {{ store?.singleLeadData?.last_name }}
                  </p>
                </div>

                <div
                  class="lead-line last-name d-flex align-center justify-space-between"
                >
                  <p class="title">Phone</p>
                  <!-- <p class="value" v-if="store?.singleLeadData?.phones">
                    {{ store?.singleLeadData?.phones?.phone }}
                  </p> -->
                  <div
                    v-if="
                      store?.singleLeadData?.phones &&
                      store?.singleLeadData?.phones.length > 0
                    "
                  >
                    <ul class="pa-0 ma-0" style="list-style: none">
                      <li
                        v-for="(phone, index) in store?.singleLeadData?.phones"
                        :key="index"
                        style="text-align: end"
                        class="phone-item"
                        :title="phone?.phone_name"
                      >
                        <span>{{ phone?.phone }}</span> -
                        <span>
                          {{
                            phone?.phone_name?.length > 8
                              ? phone.phone_name.slice(0, 8) + "..."
                              : phone?.phone_name
                          }}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <p v-else>
                    {{ store?.singleLeadData?.phone }}
                  </p>
                </div>
                <div
                  class="lead-line email-line d-flex align-center justify-space-between"
                >
                  <p class="title">Email</p>

                  <!-- لو عندك أكتر من إيميل من الـ backend -->
                  <div
                    class="value"
                    v-if="
                      store?.singleLeadData?.emails &&
                      store.singleLeadData.emails.length
                    "
                  >
                    <ul
                      class="pa-0 ma-0"
                      style="list-style: none; text-align: end"
                    >
                      <li
                        v-for="em in store.singleLeadData.emails"
                        :key="em.id || em.email"
                        class="email-item"
                        :title="em.email"
                      >
                        {{ em.email }}
                      </li>
                    </ul>
                  </div>

                  <!-- فallback لو عندك email عادي مش array -->
                  <p class="value" v-else-if="store?.singleLeadData?.email">
                    {{ store.singleLeadData.email }}
                  </p>

                  <!-- لو مفيش أي إيميل -->
                  <p class="value" v-else>Not Added</p>
                </div>

                <div
                  class="lead-line last-name mb-0 d-flex align-center justify-space-between"
                >
                  <p class="title">Marketing Campaign</p>
                  <p class="value" v-if="store?.singleLeadData?.campaign_name">
                    {{ store?.singleLeadData?.campaign_name }}
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="2" lg="2" xl="2"></v-col>
              <v-col cols="12" md="5" lg="5" xl="5">
                <div
                  class="lead-line marketing-source d-flex align-center justify-space-between"
                >
                  <p class="title">Marketing Source</p>
                  <p class="value" v-if="store?.singleLeadData?.platform">
                    {{ store?.singleLeadData?.platform }}
                  </p>
                </div>
                <div
                  class="lead-line progress-status d-flex align-center justify-space-between"
                >
                  <p class="title">Progress Status</p>
                  <p
                    class="value"
                    v-if="
                      store?.singleLeadData?.progress_status &&
                      store?.singleLeadData?.progress_status != null
                    "
                  >
                    {{ store?.singleLeadData?.progress_status }}
                  </p>
                  <p class="value" v-else>New</p>
                </div>

                <div
                  class="lead-line assigned-agent d-flex align-center justify-space-between"
                >
                  <p class="title">Assigned Agent</p>
                  <template v-if="store.singleLeadData?.assigned_agents">
                    <div
                      v-for="agent in [store.singleLeadData?.assigned_agents]"
                      :key="agent.id"
                    >
                      <img
                        style="width: 30px; height: 30px; border-radius: 50%"
                        :src="agent.img"
                        :alt="agent.name"
                      />
                    </div>
                  </template>
                </div>

                <div
                  class="lead-line progress-status d-flex align-center justify-space-between"
                >
                  <p class="title">Remarks</p>
                  <p
                    class="value"
                    v-if="
                      store?.singleLeadData?.note &&
                      store?.singleLeadData?.note != null
                    "
                  >
                    {{ store?.singleLeadData?.note }}
                  </p>
                  <p class="value" v-else>Not Added</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="store.edite_card" no-gutters>
      <v-col cols="12" class="card-info">
        <div style="border-radius: 8px; border: 1px solid #e8e8e8" class="pa-6">
          <div
            class="card-header mb-6 d-flex align-center justify-space-between"
          >
            <h2>Lead Information</h2>
            <button @click="store.saveEditLead($route.params.id)">
              <img :src="editIcon" alt="editIcon" />
              Save
            </button>
          </div>
          <div class="card-body">
            <v-row no-gutters>
              <v-col
                cols="12"
                md="5"
                lg="5"
                xl="5"
                class="d-flex flex-column ga-5"
              >
                <div
                  class="lead-line lead-time d-flex align-center justify-space-between"
                >
                  <p class="title">Leads Generation time</p>
                  <VueDatePicker
                    style="width: 50%"
                    v-model="store.singleLeadData.lead_genration_time"
                    type="date"
                  />
                </div>
                <div
                  class="lead-line first-name d-flex align-center justify-space-between"
                >
                  <p class="title">First Name</p>
                  <input
                    type="text"
                    v-model="store.singleLeadData.first_name"
                    class="form-control"
                  />
                </div>
                <div
                  class="lead-line last-name d-flex align-center justify-space-between"
                >
                  <p class="title">Last Name</p>
                  <input
                    type="text"
                    v-model="store.singleLeadData.last_name"
                    class="form-control"
                  />
                </div>

                <div
                  class="lead-line last-name d-flex align-center justify-space-between"
                >
                  <p class="title">Phone</p>
                  <input
                    v-if="store.singleLeadData.phone"
                    type="text"
                    v-model="store.singleLeadData.phone"
                    class="form-control"
                  />
                  <div class="w-50 text-left">
                    <v-btn
                      color="success"
                      style="text-align: left; width: 100%"
                      @click="dialog = true"
                      >Edit all ({{ store.singleLeadData.phones.length }})
                      Numbers</v-btn
                    >
                  </div>
                </div>
                <div
                  class="lead-line email-line d-flex align-center justify-space-between"
                >
                  <p class="title">Email</p>
                  <input
                    type="email"
                    v-model="store.singleLeadData.email"
                    class="form-control"
                  />
                </div>

                <div
                  class="lead-line last-name mb-0 d-flex align-center justify-space-between"
                >
                  <p class="title">Marketing Campaign</p>
                  <p
                    class="value w-50"
                    v-if="store?.singleLeadData?.campaign_name"
                  >
                    {{ store?.singleLeadData?.campaign_name }}
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="2" lg="2" xl="2"></v-col>
              <v-col
                cols="12"
                md="5"
                lg="5"
                xl="5"
                class="d-flex flex-column ga-5"
              >
                <div
                  class="lead-line edite-source marketing-source d-flex align-center justify-space-between"
                >
                  <p class="title w-50">Marketing Source</p>
                  <v-select
                    hide-details
                    return-object
                    v-model="store.leadSource"
                    :items="store.leadSources"
                    variant="outlined"
                    class="custom-v-select w-50"
                    no-details
                    placeholder="Select Source"
                  >
                    <template #item="{ item, props }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.title"
                      ></v-list-item>
                    </template>
                    <template #selection="{ item }">
                      <div class="d-flex align-center">
                        {{ item.raw.title }}
                      </div>
                    </template>
                  </v-select>
                </div>
                <div
                  class="lead-line progress-status d-flex align-center justify-space-between"
                >
                  <p class="title">Progress Status</p>

                  <p class="value w-50">
                    <v-select
                      v-model="store.progress_status"
                      :items="progress_status_list"
                      class="contact-v-select w-100"
                      variant="outlined"
                      hide-details
                      placeholder="Select Progress Status"
                    >
                      <template #item="{ item }">
                        <v-list-item @click="setValue(item)" style="padding: 0">
                          <div class="w-100 pa-2">
                            {{ item.title }}
                          </div>
                        </v-list-item>
                      </template>
                    </v-select>
                  </p>
                  <!-- <p class="value w-50" v-else>New</p> -->
                </div>

                <div
                  class="lead-line edite-source select-field assigned-agent d-flex align-center justify-space-between"
                >
                  <p class="title w-50">Assigned Agent</p>
                  <v-select
                    @click="store.getAgencies()"
                    hide-details
                    return-object
                    v-model="store.selectedAgency"
                    :items="store.arr_agency"
                    variant="outlined"
                    class="custom-v-select w-50"
                    placeholder="Select Agency"
                    no-details
                  >
                    <!-- تخصيص عرض العناصر داخل القائمة -->
                    <template v-slot:item="{ item }">
                      <v-list-item @click="selectedAgency(item)">
                        <div class="d-flex align-center gap-5">
                          <img
                            :src="item.raw.image"
                            alt=""
                            style="
                              width: 32px;
                              height: 32px;
                              border-radius: 50%;
                              object-fit: cover;
                              display: flex;
                            "
                          />
                          <span style="display: flex">{{
                            item.raw.first_name + " " + item.raw.last_name
                          }}</span>
                        </div>
                      </v-list-item>
                    </template>

                    <!-- تخصيص عرض القيمة المختارة -->
                    <template v-slot:selection="{ item }">
                      <div class="d-flex align-center gap-2">
                        <img
                          :src="item.raw.image"
                          alt=""
                          style="
                            width: 24px;
                            height: 24px;
                            border-radius: 50%;
                            object-fit: cover;
                            display: flex;
                          "
                        />
                        <span style="display: flex">{{
                          item.raw.first_name + " " + item.raw.last_name
                        }}</span>
                      </div>
                    </template>
                  </v-select>
                </div>

                <div
                  class="lead-line progress-status d-flex align-center justify-space-between"
                >
                  <p class="title">Remarks</p>
                  <input
                    type="text"
                    v-model="store.singleLeadData.note"
                    style="
                      width: 50%;
                      height: 40px;
                      border-radius: 8px;
                      border: 1px solid #e8e8e8;
                      padding: 8px;
                      outline: none;
                    "
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="520px">
      <v-card>
        <v-card-title class="text-h6">Edit Phone Numbers</v-card-title>
        <v-divider class="mb-3"></v-divider>
        <v-card-text>
          <div
            v-for="(phone, index) in store.singleLeadData.phones"
            :key="`ph-${index}`"
            class="mb-3 d-flex align-center ga-2"
          >
            <!-- اسم الرقم -->
            <v-text-field
              v-model="phone.phone_name"
              :label="`Name ${index + 1}`"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              style="max-width: 140px"
            />

            <!-- رقم الموبايل -->
            <v-text-field
              v-model="phone.phone"
              :label="`Phone ${index + 1}`"
              variant="outlined"
              density="comfortable"
              hide-details="auto"
              class="flex-grow-1"
              :rules="[
                (v) => !!(v && String(v).trim()) || 'Phone is required',
                (v) =>
                  !v || /^[0-9]+$/.test(String(v)) || 'Only numbers allowed',
                (v) => !v || String(v).length <= 15 || 'Max 15 digits',
              ]"
              prepend-inner-icon="mdi-phone"
              maxlength="15"
            />

            <!-- زر حذف -->
            <v-tooltip text="Remove" location="top">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="tonal"
                  color="#237276"
                  class="btn-icon"
                  @click="removePhone(index)"
                >
                  <v-icon color="#237276">mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>

          <!-- زر إضافة dashed -->
          <v-btn
            variant="outlined"
            color="#237276"
            block
            class="btn-add-dashed"
            @click="addPhone"
          >
            <v-icon start>mdi-plus</v-icon>
            Add another phone
          </v-btn>
        </v-card-text>

        <v-divider class="mt-2"></v-divider>

        <v-card-actions class="pa-4 actions-sticky">
          <v-spacer></v-spacer>

          <v-btn variant="text" class="px-4" @click="dialog = false">
            Cancel
          </v-btn>

          <v-btn
            color="#237276"
            variant="elevated"
            class="px-5"
            @click="savePhones"
          >
            <v-icon start>mdi-content-save</v-icon> Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import backIcon from "@/assets/images/brandify/icon (2).svg";
import editIcon from "@/assets/images/brandify/edite_icon.svg";
import VueDatePicker from "@vuepic/vue-datepicker";
import dayjs from "dayjs";
export default {
  components: {
    VueDatePicker,
  },
  data() {
    return {
      backIcon,
      editIcon,
      store: useLeadsStore(),
      progress_status_list: ["New", "In Progress", "Recycled", "Dead"],
      dialog: false,
    };
  },

  mounted() {
    console.log(this.$route.params.id);
    this.store.getALead(this.$route.params.id);
  },

  methods: {
    savePhones() {
      const cleaned = (this.store.singleLeadData.phones || [])
        .map((p) => {
          const phone = String(p?.phone ?? "").replace(/\D/g, ""); // أرقام بس
          const phone_name = String(p?.phone_name ?? "").trim();
          const id = p?.id ?? null;

          return { id, phone, phone_name };
        })
        // شيل الفاضي
        .filter((p) => p.phone.length > 0)
        // شيل التكرار حسب الرقم
        .filter((p, i, arr) => arr.findIndex((x) => x.phone === p.phone) === i);

      this.store.singleLeadData.phones = cleaned;
      this.dialog = false;
    },

    addPhone() {
      if (!Array.isArray(this.store.singleLeadData.phones)) {
        this.store.singleLeadData.phones = [];
      }
      this.store.singleLeadData.phones.push({
        id: null,
        phone: "",
        phone_name: "",
      });
    },

    removePhone(index) {
      this.store.singleLeadData.phones.splice(index, 1);
    },
    setValue(item) {
      this.store.progress_status = item.title;
    },
    goBack() {
      this.$router.go(-1);
    },
    updateLeadSource() {
      this.store.leadSource = this.store.leadSources.find(
        (item) => item.value === this.store.leadSource.value
      );
    },
    updateLeadSource() {
      this.store.leadSource = this.store.leadSources.find(
        (item) => item.value === this.store.leadSource.value
      );
    },
    selectedSource(item) {
      this.store.createLeadData.source = item.raw.value;
    },

    selectedAgency(item) {
      this.store.selectedAgency = item.raw;
      this.store.createLeadData.agent_id = item.raw.id;
    },
    updateLeadAgency(newValue) {
      this.store.selectedAgency = newValue;
    },
    onEdit() {
      this.store.getAgencies();
      this.store.editLead();
      this.store.progress_status = this.store?.singleLeadData?.progress_status;
      if (
        Array.isArray(this.store.singleLeadData.emails) &&
        this.store.singleLeadData.emails.length
      ) {
        this.store.singleLeadData.email =
          this.store.singleLeadData.emails[0]?.email || "";
      }
    },
  },
  computed: {
    formattedLeadTime() {
      const time = this.store.singleLeadData?.lead_genration_time;
      return time ? dayjs(time).format("D MMM YYYY [at] h:mm A") : "";
    },
  },
  watch: {
    "store.singleLeadData": {
      handler(val) {
        if (val) {
          if (!Array.isArray(val.phones)) {
            const initial = val.phone ? [{ phone: String(val.phone) }] : [];
            this.store.singleLeadData.phones = initial;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 50%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  padding: 8px;
  outline: none;
}
::v-deep(.contact-v-select) {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  padding: 0px;
  outline: none;
}
::v-deep(.contact-v-select .v-field__outline) {
  display: none !important;
}
.btn-add-dashed {
  border-style: dashed !important;
  border-width: 2px !important;
  border-radius: 12px !important;
  height: 44px;
  font-weight: 600;
}

.btn-icon {
  width: 40px !important;
  height: 40px !important;
  border-radius: 999px !important;
}

.actions-sticky {
  /* لو حابب تخلي الأزرار ثابتة تحت لما الليست تطول */
  position: sticky;
  bottom: 0;
  background: white;
}
.phone-item {
  cursor: default;
  line-height: 1.6;
}
</style>
